import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppComponent, TrialDialog } from './app.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { SideBarComponent, DialogContentExampleDialog2, QuestionCreator } from './side-bar/side-bar.component';
import { McPaperComponent, AnswerDialog, YoutubeDialog, SafePipe } from './mc-paper/mc-paper.component';
import { HomePageComponent } from './home-page/home-page.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { McPaperAnsComponent } from './mc-paper-ans/mc-paper-ans.component';
import { SqPaperComponent, DialogContentExampleDialog, SQAnswerDialog } from './sq-paper/sq-paper.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { AngularFireAuthGuard } from '@angular/fire/auth-guard';
import { GoogleLoginComponent } from './google-login/google-login.component';
import { TeacherHomeComponent } from './teacher-home/teacher-home.component';
import { McAnalysisComponent } from './mc-analysis/mc-analysis.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SafePipeModule } from 'safe-pipe';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
@NgModule({
   declarations: [
      AppComponent,
      TopBarComponent,
      SideBarComponent,
      McPaperComponent,
      HomePageComponent,
      McPaperAnsComponent,
      SqPaperComponent,
      DialogContentExampleDialog,
      DialogContentExampleDialog2,
      SQAnswerDialog,
      TrialDialog,
      AnswerDialog,
      YoutubeDialog,
      QuestionCreator,
      GoogleLoginComponent,
      TeacherHomeComponent,
      McAnalysisComponent,
      SafePipe,
      AdminHomeComponent
   ],
   entryComponents: [
      SqPaperComponent,
      SQAnswerDialog,
      DialogContentExampleDialog,
      DialogContentExampleDialog2,
      QuestionCreator,
      TrialDialog,
      AnswerDialog,
      YoutubeDialog
   ],
   imports: [
      AngularFireAuthModule,
      //importsfirebase/auth,
      BrowserModule,
      AngularFireModule.initializeApp(environment.firebase),
      HttpClientModule,
      BrowserAnimationsModule,
      MatTooltipModule,
      MatSidenavModule,
      MatDialogModule,
      MatButtonModule,
      MatSlideToggleModule,
      MatCardModule,
      MatButtonToggleModule,
      MatRadioModule,
      MatProgressBarModule,
      MatFormFieldModule,
      MatTabsModule,
      MatCheckboxModule,
      MatSelectModule,
      MatExpansionModule,
      MatSnackBarModule,
      SafePipeModule,
      FormsModule,
      RouterModule.forRoot([

         { path: 'mc/:exam/:type/:paperId', component: McPaperComponent, data: { animation: 'FilterPage' } },
         { path: 'mc/ans/:exam/:type/:paperId', component: McPaperAnsComponent, },
         { path: 'sq/:exam/:type/:paperId', component: SqPaperComponent, data: { animation: 'AboutPage' } },
         { path: '', component: HomePageComponent, data: { animation: 'HomePage' } },
         { path: 'teacher', component: TeacherHomeComponent, data: { animation: 'HomePage' } },
         { path: 'admin', component: AdminHomeComponent, data: { animation: 'HomePage' } },
         { path: 'teacher/mc', component: McAnalysisComponent, data: { animation: 'HomePage' } },

      ])
   ],
   providers: [],
   bootstrap: [
      AppComponent
   ]
})
export class AppModule { }
